/**
 * The Resource class is used as parent for all types of resources.
 * @class Resource
 */
export class Resource {}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Resources/Resource.ts
 **/